<template>
  <AmTypography
    :text="$t('amReactivateAppModal.contentOne')"
  />
  <AmTypography
    :text="$t('amReactivateAppModal.contentTwo', { email: 'desenvolvedores@appmax.com.br' })"
  />

  <AmButton
    :label="$t('amReactivateAppModal.understand')"
    variant="maxPrimary"
    :size="mq.current === 'mobile' ? 'fullWidth' : 'large'"
    :class="mq.current === 'mobile' ? 'mt-4' : 'float-right mt-4'"
    @click="closeModal()"
  />
</template>

<script setup>
import { AmButton, AmTypography } from '@appmax_npm/ds-appmax-v3'
import { inject } from 'vue'

const mq = inject('mq')
const emit = defineEmits(['understandModalReactivate'])

const closeModal = () => {
  emit('understandModalReactivate', false)
};
</script>
